import { APITabularMappingAttributes } from '@ardoq/api-types/integrations';
import { fetchEntities } from './api';

export const tabularMappingApi = {
  fetchAll: fetchEntities<APITabularMappingAttributes>(
    'integrations/tabular/mapping'
  ),
};
